var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ7C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4702 49.3771L89.9641 33.3204L158.58 75.1471L126.84 93.4771L50.4702 49.3771Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.84 240.147L50.4702 196.047V49.5569L126.84 93.6569V240.147Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4399 184.65C76.2799 187.43 80.22 185.16 80.22 179.58C80.22 174 76.2999 167.19 71.4399 164.39C66.6099 161.61 62.6699 163.85 62.6699 169.46C62.6699 175.07 66.6099 181.85 71.4399 184.65ZM71.5049 181.213C74.5287 183.053 77 181.56 77 177.85V177.84C77 174.692 75.2265 170.982 72.823 168.805C72.3965 168.406 71.9507 168.079 71.5049 167.793C71.0494 167.507 70.6036 167.292 70.1772 167.18C67.7736 166.444 66 168.008 66 171.156C66 174.845 68.452 179.363 71.5049 181.213Z",
    fill: "#F97E73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.73 168.57V174.94L70 173.37V167C70.44 167.12 70.9 167.32 71.37 167.6C71.83 167.88 72.29 168.2 72.73 168.57Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4399 199.65C102.28 202.43 106.21 200.16 106.21 194.58C106.21 189 102.3 182.19 97.4399 179.39C92.5999 176.61 88.6699 178.85 88.6699 184.46C88.6699 190.07 92.5999 196.85 97.4399 199.65ZM97.1803 195.631C100.31 197.431 102.85 195.971 102.85 192.341V192.331C102.85 189.251 101.03 185.621 98.5503 183.491C98.1103 183.101 97.6503 182.781 97.1803 182.501C96.7203 182.221 96.2602 182.021 95.8202 181.901C93.3402 181.181 91.5103 182.711 91.5103 185.791C91.5103 189.401 94.0303 193.831 97.1803 195.631Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8302 182.949V189.319L96.1001 187.749V181.379C96.5401 181.499 97.0002 181.699 97.4602 181.979C97.9302 182.259 98.3902 182.559 98.8302 182.949Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.53 192.717C175.3 208.527 151.08 224.337 126.84 240.147V93.6572C151.45 79.7472 176.06 65.8272 200.67 51.8972C200.3 98.8472 199.9 145.767 199.53 192.717Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4702 49.5571C62.5902 42.9571 74.7202 36.3871 86.8602 29.8371C98.9802 23.2971 111.11 16.7871 123.26 10.2971C149.07 24.1671 174.86 38.0271 200.67 51.8971C186.959 60.3644 139.14 86.6471 126.84 93.6571L50.4702 49.5571Z",
    fill: "#72D09A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8999 150.061C79.8999 151.731 78.7499 152.401 77.2899 151.571C75.8499 150.741 74.6699 148.721 74.6699 147.061C74.6699 145.401 75.8299 144.721 77.2899 145.551C78.7199 146.381 79.8999 148.421 79.8999 150.061Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8398 161.011C98.8398 162.681 97.6798 163.351 96.2198 162.511C94.7898 161.681 93.6099 159.661 93.6099 158.001C93.6099 156.341 94.7698 155.661 96.2198 156.491C97.6798 157.321 98.8398 159.341 98.8398 161.001V161.011Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.75 93.4768L101.63 110.647V115.297L71.75 98.1268V93.4768Z",
    fill: "#F97E73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.75 103.247L101.63 120.417V125.087L71.75 107.917V103.247Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.75 113.047L101.63 130.217V134.867L71.75 117.697V113.047Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ7C);
export default __webpack_public_path__ + "static/media/q7c.bdfdee0f348a61390ce1496211bcf567.svg";
export { ForwardRef as ReactComponent };